/* eslint-disable @typescript-eslint/no-unused-vars */
import { Article } from 'Types/ArticleTypes';
import {
  NavigateFunction, useLocation, useNavigate, useSearchParams,
} from 'react-router-dom';
import { selectIsPagination } from 'Selector/GlobalSearchResultsSelector';
import { useDispatch, useSelector } from 'react-redux';
import {
  ArticleSlicerResultPage,
  formatNumberWithCommas,
  MaxWidthApp, valueToObject,
} from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { FEED_GILROY_ROUTE, SEARCH_ROUTE } from 'Utils/Constants';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import { SearchResultsRouteState } from 'Pages/search/GlobalSearchResults';
import HeadingWithShowAll from './HeadingWithShowAll';
import SectionHeading from './SectionHeading';

type Props = {
  heading: string,
  articlesCollection?: Article[],
  loading?: boolean,
  query: string,
  articleCount?: Article[],
  count?: number,
  setArticleTop?: (a: string) => void,
  inGlobalSearch?: boolean,
} & typeof defaultProps;

const defaultProps = {
  loading: false,
  articlesCollection: [] as Article[],
  articleCount: [] as Article[],
  count: 0,
  setArticleTop(a: string) { },
  inGlobalSearch: false,
};

const ArticlesSection = function ArticlesSection(props: Props) {
  const host = window.location.href;
  const [searchParams] = useSearchParams();
  const extendedSections = ['person', 'company', 'article'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);
  const navigate: NavigateFunction = useNavigate();
  const isPagination: boolean = useSelector(selectIsPagination);
  const slicerArticleNumber: number = ArticleSlicerResultPage();
  const {
    heading, articlesCollection, loading, query, articleCount, count, inGlobalSearch,
    setArticleTop,
  } = props;
  const maxWidthApp = MaxWidthApp();
  const formattedCount = formatNumberWithCommas(count);
  const location = useLocation();
  const { state } = location as { state: SearchResultsRouteState };
  const previousPath = (state)?.previousPath ?? FEED_GILROY_ROUTE;
  const dispatch = useDispatch();

  const createArticlesRoute = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('searchPage_articles_see_all_clicked', 0, {
        host,
      }),
    ));
    window.scrollTo(0, 0);
    setArticleTop('article');
    return navigate(`${SEARCH_ROUTE}${query}&extend=article`, { state: { enableBackButton: true, previousPath } });
  };

  const navigateToSearchResult = () => {
    const path = `${SEARCH_ROUTE}${query}`;
    navigate(path, {
      state: isDetailedSearch ? { enableBackButton: true, previousPath } : { previousPath },
    });
  };

  return (
    loading
      ? <ArticleLoadingSkeletonBundle />
      : (
        <>
          <HeadingWithShowAll
            inGlobalSearch={inGlobalSearch}
            isShowAllHidden={isDetailedSearch ? true
              : articleCount && articleCount.length <= slicerArticleNumber}
            leftHeading={(
              <SectionHeading customClassName="global-search-heading">{`${heading} (${formattedCount})`}</SectionHeading>)}
            onClick={createArticlesRoute}
            onSeelessClick={navigateToSearchResult}
            isDetailedSearch={isDetailedSearch}
          />
          <div className="w-100">

            <ArticleGridLayout
              isLoading={isPagination}
              articlesArray={articlesCollection}
            />
          </div>

          {isDetailedSearch && isPagination && <ArticleLoadingSkeletonBundle />}
        </>
      ));
};
ArticlesSection.defaultProps = defaultProps;
export default ArticlesSection;
